export const FARMER_LABEL = 'รายชื่อเกษตร';
export const CROPS_LABEL = 'ตารางผลิตผล';
export const CERTS_LABEL = 'ใบรับรอง';
